/**
 * Cart images often contain callouts and short remarks rather than a simple
 * product photo. Keep enough preview area to recognise those annotations and
 * never crop the source image.
 */
export const CART_IMAGE_PRESENTATION = {
  card: { width: 96, height: 72 },
  table: { width: 96, height: 68 },
  fit: 'contain',
} as const;
